var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",{"id":"Download"},[React.createElement("path",{"d":"M372.9,264.7c-6.6,0-12,5.4-12,12v84.2H24.1v-84.2c0-6.6-5.4-12-12-12s-12,5.4-12,12v96.2c0,6.6,5.4,12,12,12h360.9\n\t\t\tc6.6,0,12-5.4,12-12v-96.2C385,270.1,379.6,264.7,372.9,264.7z","key":0}),React.createElement("path",{"d":"M183.7,285.2c4.7,4.6,12.5,4.7,17.2,0l84.2-83c4.8-4.7,4.7-12.3,0-17c-4.7-4.7-12.4-4.7-17.2,0l-63.5,62.6V12\n\t\t\tc0-6.6-5.4-12-12.2-12s-12.2,5.4-12.2,12v235.7l-63.5-62.6c-4.8-4.7-12.4-4.7-17.2,0c-4.8,4.7-4.8,12.3,0,17L183.7,285.2z","key":1})])));
}

Download.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","width":"385px","height":"385px","viewBox":"0 0 385 385","style":{"enableBackground":"new 0 0 385 385"},"xmlSpace":"preserve"};

module.exports = Download;

Download.default = Download;
